import React from "react";

/**
 * A standalone timer component that manages its own interval.
 * This prevents the parent component from re-rendering every second.
 */
export const MeetingTimer = ({ isAnalyzing }) => {
  const [elapsed, setElapsed] = React.useState(0);

  React.useEffect(() => {
    let interval = null;
    if (isAnalyzing) {
      interval = setInterval(() => {
        setElapsed((prev) => prev + 1);
      }, 1000);
    } else {
      // Do not reset elapsed time to 0 here.
      // setElapsed(0);
      if (interval) clearInterval(interval);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isAnalyzing]);

  // specific condition check removed to show always admin start and stop
  // if (!isAnalyzing) return null;

  return (
    <div className="text-sm font-semibold text-red-600">
      Duration: {Math.floor(elapsed / 60)}m {elapsed % 60}s
    </div>
  );
};

export default React.memo(MeetingTimer);
